var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.303711,
    width: 31.3225,
    height: 27.6338,
    rx: 9,
    fill: "#626687",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4111 21.0018L15.3236 20.0118C11.4611 16.5093 8.91113 14.1918 8.91113 11.3643C8.91113 9.04676 10.7261 7.23926 13.0361 7.23926C14.3411 7.23926 15.5936 7.84676 16.4111 8.79926C17.2286 7.84676 18.4811 7.23926 19.7861 7.23926C22.0961 7.23926 23.9111 9.04676 23.9111 11.3643C23.9111 14.1918 21.3611 16.5093 17.4986 20.0118L16.4111 21.0018Z",
    fill: "#FD2A2A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavFill);
export default __webpack_public_path__ + "static/media/FavFill.2279186eefdef3277d6d6bdf52cac8d1.svg";
export { ForwardRef as ReactComponent };